import { combineReducers } from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "CONFIG_SESSION_ERROR":
            return action.error;

        case "CONFIG_SESSION_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "CONFIG_SESSION_LOADING":
            return action.loading;

        case "CONFIG_SESSION_RESET":
            return false;

        default:
            return state;
    }
}

export function data(state = {}, action) {
    switch (action.type) {
        case "CONFIG_SESSION_SET": {
            return action.data;
        }
        case "CONFIG_SESSION_UPDATE": {
            const { token, iat, exp, roles, refresh_token } = action.data;
            return {
                ...state,
                token,
                iat,
                exp,
                roles,
                refresh_token,
            };
        }

        case "CONFIG_SESSION_SET_IMAGE": {
            return {
                ...state,
                loginImage: action.data,
            };
        }

        case "CONFIG_SESSION_RESET": {
            const { subdomain, loginImage } = state;
            return { subdomain, loginImage };
        }
        default:
            return state;
    }
}

export default combineReducers({ error, loading, data });
